import poll from './poll';
import { nodeChatOnPageValidator } from './node-chat-on-page-validator';
import fireImpressionFptiForChatLoadError from './fire-impression-fpti-for-chat-load-error';

// the Poll function will retry for at least 2 secs based on current retries = 10 and delay = 200 ms
const pollRetries = 5;
const pollDelay = 200;

// eslint-disable-next-line
export const isChatBotCardOrPillPresentOnPage = () => {
  const chatPromptCard = document.getElementById('chat-question-card');
  if (chatPromptCard && chatPromptCard.style.display !== null) {
    return true;
  }

  const chatNowBtn = document.getElementById('chat-now-btn');
  return (chatNowBtn && chatNowBtn.style.display !== null);
};

export const initiateChatBot = (topicRefId) => window.nodeChat.show('chatBot', topicRefId);

// Waits at least 3.20 secs based on current retries = 5 and delay = 200 ms
export const initializeChatBot = ({ topicRefId, link, hpid = '' }) => poll(nodeChatOnPageValidator, pollRetries, pollDelay)
  // eslint-disable-next-line no-undef
  .then(() => initiateChatBot(topicRefId))
  .catch(() => fireImpressionFptiForChatLoadError(link, hpid));

export const initializeLiveChat = (topicRefId) => poll(nodeChatOnPageValidator, pollRetries, pollDelay)
  // eslint-disable-next-line no-undef
  .then(() => nodeChat.show('liveChat', `${topicRefId}|finalIntent`))
  .catch(() => fireImpressionFptiForChatLoadError('chat-shown'));

export const wasChatBotClicked = () => (window.sessionStorage && sessionStorage.getItem('chatBotClicked') === 'true');

export const wasLiveChatClicked = () => (window.sessionStorage && sessionStorage.getItem('liveChatClicked') === 'true');

export const isChatCardClicked = () => (window.sessionStorage && sessionStorage.getItem('chatCardClicked') === 'true');

export const isChatBotClickedOnArticlePage = () => ((typeof sessionStorage === 'object') && sessionStorage.getItem('articlePagechatBotClicked') === 'true');

export const setChatBotClickInSession = (value = false) => {
  sessionStorage.setItem('chatBotClicked', value);
};

export const setLiveChatClickInSession = (value = false) => {
  sessionStorage.setItem('liveChatClicked', value);
};

export const setArticlePageChatBotClickInSession = (value = false) => {
  sessionStorage.setItem('articlePagechatBotClicked', value);
};

export const setChatCardClickInSession = (value = false) => {
  sessionStorage.setItem('chatCardClicked', value);
};

export const resetAllChatClicksInSession = () => {
  sessionStorage.removeItem('chatBotClicked');
  sessionStorage.removeItem('liveChatClicked');
  sessionStorage.removeItem('articlePagechatBotClicked');
};

// TODO:: refactor this after validating
export const getChatAction = (topicRefId) => {
  setChatCardClickInSession(true);
  setLiveChatClickInSession(true);

  return poll(nodeChatOnPageValidator, pollRetries, pollDelay)
  // eslint-disable-next-line no-undef
    .then(() => nodeChat.show('liveChat', `${topicRefId}|finalIntent`))
    .catch(() => fireImpressionFptiForChatLoadError('chat-shown'));
};
